export enum ExceptionType {
  DATE,
  PRICE,
  OUT_OF_STOCK,
  PRODUCT_UNAVAILABLE,
  RESTRICTED,
  UNUSUAL_QUANTITY,
  ACKNOWLEDGEMENT,
}

export const getExceptionTitle: {
  [status in ExceptionType]: string;
} = {
  [ExceptionType.DATE]: 'Date',
  [ExceptionType.PRICE]: 'Pricing',
  [ExceptionType.OUT_OF_STOCK]: 'Products Out of Stock',
  [ExceptionType.PRODUCT_UNAVAILABLE]: 'Products Unavailable',
  [ExceptionType.RESTRICTED]: 'Restricted',
  [ExceptionType.UNUSUAL_QUANTITY]: 'Unusual Quantity',
  [ExceptionType.ACKNOWLEDGEMENT]: 'Acknowledgement',
};

export const getExceptionDescription: {
  [status in ExceptionType]: string;
} = {
  [ExceptionType.DATE]: 'The delivery date selected is invalid.',
  [ExceptionType.PRICE]: 'The prices you’ve set need updating.',
  [ExceptionType.OUT_OF_STOCK]:
    'The quantity ordered for these products exceeds the currently available inventory.',
  [ExceptionType.PRODUCT_UNAVAILABLE]:
    'Some of the products ordered are no longer available.',
  [ExceptionType.RESTRICTED]:
    'These products are currently restricted. Please contact your sales team for more information.',
  [ExceptionType.UNUSUAL_QUANTITY]:
    'Please confirm the quantities for the products below.',
  [ExceptionType.ACKNOWLEDGEMENT]:
    'Please confirm the following messages regarding these products.',
};

export enum ErrorType {
  DATE = 'DATE',
  PRICE = 'PRICE',
  SUBSTITUTE = 'SUB',
  REPLACEMENT = 'RPL',
  QUANTITY = 'QTY',
  ACKNOWLEDGEMENT = 'ACK',
}

export const RestrictedErrorCodes: number[] = [741, 742, 743, 750];
